import { useServices } from 'containers/services';
import { useAppNotifications } from 'hooks';
import type { DeleteMeterModuleArg, DeleteMeterModuleResult } from 'lib/services';
import { useMutation, type UseMutationResult, useQueryClient } from 'react-query';
import { getErrorMessage } from 'utils/getErrorMessage';
import { MUTATION_KEYS, QUERY_KEYS } from 'utils/queryKeys';

export const useDeleteMeterModule = (): UseMutationResult<DeleteMeterModuleResult, unknown, DeleteMeterModuleArg> => {
  const queryClient = useQueryClient();
  const { meterModulesApiClient } = useServices();
  const { success, error } = useAppNotifications();

  return useMutation({
    mutationKey: MUTATION_KEYS.meterModules.deleteOne(),
    mutationFn: async (arg: DeleteMeterModuleArg) => await meterModulesApiClient.delete(arg),
    onError: err => {
      console.error(err);
      error({
        message: 'There was an error while deleting meter module',
        description: getErrorMessage(err),
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries(QUERY_KEYS.meterModules.all());
      success({
        message: `Meter module deleted`,
      });
    },
  });
};
